import { Component } from '@angular/core';
import { NxIconModule } from '@allianz/ng-aquila/icon';
import { NxHeadlineModule } from '@allianz/ng-aquila/headline';
import { NxMessageModule } from '@allianz/ng-aquila/message';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'app-payment-verification',
  imports: [
    NxIconModule,
    NxHeadlineModule,
    NxMessageModule,
    TranslocoPipe,
  ],
  templateUrl: './payment-verification.component.html',
  styleUrl: './payment-verification.component.scss'
})
export class PaymentVerificationComponent {

}
